//react
import { useState          } from 'react';

//bootstrap
import { Alert             } from 'react-bootstrap';

import { useNavigate } from "react-router-dom";

//stripe
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

//spotsync
import { SubscribeUpdateInitResp } from "./Data/ApiTypes";
import { showMoney         } from "./Data/Money";
import { Button            } from "./Controls/Button";
import { connectUrl        } from './Data/WebUrl';
import { PageMaskOpts, maskAtom  } from './Data/Atoms';
import { useAtom                 } from 'jotai';  
import { toast } from 'react-toastify';
import { createApiService } from './shared/apiConfig';
import { WaitlistApi } from './shared/api/axios-client';

export function StripeMonthlyUpdateCheckoutForm( { init, subscriptionId, waitlistEntryId }: { init: SubscribeUpdateInitResp, subscriptionId:number, waitlistEntryId?: number } ) {
    const [msg, setMsg] = useState<string>();
    const stripe   = useStripe();
    const elements = useElements();
    const nav = useNavigate();

    const maskOptions: PageMaskOpts = {
        showMask: true,
        header:  <div className="h2">Processing Payment</div>,
        subText: 'Do not close your browser',
    };

    const [, setShowMask] = useAtom( maskAtom );

    const handleSubmit = async ( event: any ) => {
        event.preventDefault();

        if( !stripe || !elements ) {
            return;
        }

        //trigger form validation and wallet collection
        const { error: submitError } = await elements.submit();
        if( submitError ) {
            return;
        }

        setShowMask( maskOptions );

        if (waitlistEntryId)
        {
            try {
                const waitlistApi = createApiService(WaitlistApi);
                const result = await waitlistApi.setWailitEntryAsAccepted({
                    id: waitlistEntryId
                });

                if (result.data.error) {
                    toast.error(result.data.error);
                    return;
                }
                } catch {
                toast.error("An unexpected error occurred. Please try again later.");
            }
        }

        const result = await stripe.confirmPayment( {
            elements,
            confirmParams: {
            return_url: connectUrl(
            `/paid?` +
            `returnTo=${encodeURIComponent(`/user/plan/${subscriptionId}`)}` +
            `&returnLabel=${encodeURIComponent('Back To Plan')}`
            )
            },
        } );

        if( result.error ) {
            // Show error to your customer (for example, payment details incomplete)
            setMsg( result.error.message );
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
        setShowMask( undefined );
    };

    return <form onSubmit={handleSubmit}>
        <PaymentElement />
        <div className="d-flex justify-content-end gap-1">
            <Button className="w-100 mt-2 px-3" onClick={ () => nav( `/user/plan/${subscriptionId}` ) }>
                Cancel
            </Button>
            <Button type="submit" disabled={!stripe} className="w-100 mt-2 px-3 btn-main">
                Pay {showMoney( init.price )}
            </Button>
        </div>
        <br />
        {msg && <Alert variant="danger">
            {msg}
        </Alert>}
    </form>
};

